/* eslint-disable camelcase */

import type { RoomInputData } from '../../components/CounterInput';

export const Types = {
  SET_SEARCH: 'search/SET_SEARCH',
  SET_SEARCH_DESTINATION: 'search/SET_SEARCH_DESTINATION',
  SET_SEARCH_DATES: 'search/SET_SEARCH_DATES',
  SET_SEARCH_OCCUPANCY: 'search/SET_SEARCH_OCCUPANCY',
  SET_SEARCH_ROOMS_AND_TRAVELERS: 'search/SET_SEARCH_ROOMS_AND_TRAVELERS',
};

type ISearchDates = {
  checkin: string;
  checkout: string;
};

type ISearchDestination = {
  name: string;
  region: string;
  type: 'place' | 'hotel' | '';
  id: string;
};

export interface ISearchReduxState extends ISearchDates, ISearchDestination {
  rooms: RoomInputData[];
  occupancy: string[];
}

const initialState: ISearchReduxState = {
  rooms: [
    {
      id: 1,
      adults: 1,
      children: [],
    },
  ],
  name: '',
  region: '',
  type: '',
  id: '',
  checkin: '',
  checkout: '',
  occupancy: [],
};

export default function reducer(state = initialState, action: any = {}): ISearchReduxState {
  switch (action.type) {
    case Types.SET_SEARCH_DESTINATION:
      return {
        ...state,
        id: action.payload.id,
        name: action.payload.name,
        region: action.payload.region,
        type: action.payload.type,
      };
    case Types.SET_SEARCH_DATES:
      return {
        ...state,
        checkin: action.payload.checkin,
        checkout: action.payload.checkout,
      };
    case Types.SET_SEARCH_OCCUPANCY:
      return {
        ...state,
        occupancy: action.payload,
      };
    case Types.SET_SEARCH_ROOMS_AND_TRAVELERS:
      return {
        ...state,
        rooms: action.payload,
      };
    case Types.SET_SEARCH:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

const setSearch = (search: ISearchReduxState) => ({
  type: Types.SET_SEARCH,
  payload: search,
});

const setSearchDates = (dates: ISearchDates) => ({
  type: Types.SET_SEARCH_DATES,
  payload: dates,
});

const setSearchDestination = (destination: ISearchDestination) => ({
  type: Types.SET_SEARCH_DESTINATION,
  payload: destination,
});

const setSearchOccupancy = (occupancy: string[]) => ({
  type: Types.SET_SEARCH_OCCUPANCY,
  payload: occupancy,
});

const setSearchRoomsAndTravelers = (rooms: RoomInputData[]) => ({
  type: Types.SET_SEARCH_ROOMS_AND_TRAVELERS,
  payload: rooms,
});

export const searchActions = {
  setSearch,
  setSearchDates,
  setSearchDestination,
  setSearchOccupancy,
  setSearchRoomsAndTravelers,
};
